import React from 'react';
import { Modal } from '@gerdau/hefesto';
import { Container, Subtitle } from './styles';

interface Props {
  title: string;
  message: string;
  onClose: () => void;
}

const TicketUnavailableModal = ({ title, message, onClose }: Props) => {
  return (
    <Modal
      buttons={{
        right: {
          children: 'Fechar',
          name: 'fechar',
          onClick: onClose,
          type: 'button',
          variant: 'primary'
        }
      }}
      modalSize="sm"
      title={title}
    >
      <Container>
        <Subtitle>{message}</Subtitle>
      </Container>
    </Modal>
  );
};

export default TicketUnavailableModal;
